// Messages of the "Marketing" module. Spanish is the reference; English is
// the fallback for the other locales.
export const marketingSpanishMessages = {
  marketing: {
    title: "Marketing",
    tabs: {
      label: "Secciones de marketing",
      summary: "Resumen",
      calendar: "Calendario",
      pipeline: "Pipeline",
      plans: "Planes",
      channels: "Canales",
      analytics: "Analíticas",
    },
    status: {
      label: "Estado",
      idea: "Idea",
      guion: "Guion",
      produccion: "En producción",
      programado: "Programado",
      publicado: "Publicado",
    },
    format: {
      label: "Formato",
      imagen: "Imagen",
      carrusel: "Carrusel",
      reel: "Reel",
      short: "Short",
      video_largo: "Vídeo largo",
      post: "Post",
      story: "Story",
      anuncio: "Anuncio",
      articulo: "Artículo",
      otro: "Otro",
    },
    vertical: {
      label: "Vertical",
      clinicas: "Clínicas",
      inmobiliarias: "Inmobiliarias",
      pymes: "Pymes",
      general: "General",
      otro: "Otro",
    },
    plan_status: {
      label: "Estado del plan",
      borrador: "Borrador",
      activo: "Activo",
      finalizado: "Finalizado",
    },
    channel_status: {
      label: "Estado del canal",
      activo: "Activo",
      pausado: "Pausado",
    },
    source: {
      manual: "Manual",
      agente: "Agente",
      api: "API",
    },
    common: {
      error: "No se han podido cargar los datos de marketing.",
      all_channels: "Todos los canales",
      all_plans: "Todos los planes",
      no_channel: "Sin canal",
      no_plan: "Sin plan",
      none: "Ninguno",
      unassigned: "Sin responsable",
      new_piece: "Nueva pieza",
      week_short: "Sem. %{week}",
      week_long: "Semana %{week}",
      overdue: "Atrasada",
      filter_channel: "Filtrar por canal",
      filter_plan: "Filtrar por plan",
      channels_short: "Canales",
      plans_short: "Planes",
    },
    summary: {
      heading: "Resumen de marketing",
      kpi_scheduled: "Programadas esta semana",
      kpi_published: "Publicadas este mes",
      kpi_leads: "Leads del mes",
      kpi_spend: "Gasto del mes",
      upcoming: "Próximas publicaciones",
      upcoming_empty: "No hay publicaciones previstas.",
      see_calendar: "Ver calendario",
      competitors: "Actividad reciente de la competencia",
      competitors_empty: "Todavía no hay actividad de la competencia.",
      see_trends: "Ver tendencias",
      key_week: "Esta semana",
      key_week_hint:
        "Guardados, envíos y mensajes directos de la última semana con datos.",
    },
    calendar: {
      heading: "Calendario de contenido",
      view_label: "Vista del calendario",
      month: "Mes",
      week: "Semana",
      list: "Lista",
      previous: "Anterior",
      next: "Siguiente",
      today: "Hoy",
      add_on_day: "Nueva pieza el %{day}",
      empty_day: "Nada previsto este día.",
      empty_list: "No hay piezas en este periodo.",
      more: "+%{count}",
      pieces: "%{smart_count} pieza |||| %{smart_count} piezas",
    },
    pipeline: {
      heading: "Pipeline de contenido",
      empty_column: "Arrastra aquí",
      moved: "Pieza movida a «%{status}»",
      error: "No se ha podido mover la pieza.",
      status_label: "Columna",
    },
    plans: {
      heading: "Planes de contenido",
      new: "Nuevo plan",
      edit: "Editar plan",
      empty: "Todavía no hay planes.",
      empty_hint: "Crea un plan con sus pilares, fases y cadencia por canal.",
      period: "Periodo",
      no_period: "Sin fechas",
      weeks: "%{smart_count} semana |||| %{smart_count} semanas",
      objective: "Objetivo",
      pillars: "Pilares",
      phases: "Fases",
      cadence: "Cadencia por canal",
      per_week: "%{count}/semana",
      progress: "Progreso",
      progress_value: "%{published} de %{planned} publicadas",
      target: "Objetivo por cadencia: %{count} piezas",
      pieces: "Piezas del plan",
      no_pieces: "Este plan todavía no tiene piezas.",
      no_week: "Sin semana",
      phase_name: "Fase %{number}",
      phase_weeks: "Semanas %{from}–%{to}",
      back: "Volver a planes",
      not_found: "No se ha encontrado el plan.",
      deleted: "Plan eliminado",
      delete: "Eliminar plan",
      current_week: "Semana actual",
      form: {
        name: "Nombre",
        objective: "Objetivo",
        start_date: "Inicio",
        end_date: "Fin",
        notes: "Notas",
        pillars: "Pilares",
        pillar_code: "Código",
        pillar_name: "Nombre del pilar",
        pillar_description: "Descripción",
        add_pillar: "Añadir pilar",
        phases: "Fases",
        phase_number: "Nº",
        phase_name: "Nombre",
        phase_start: "Semana inicial",
        phase_end: "Semana final",
        phase_cadence: "Ritmo",
        add_phase: "Añadir fase",
        cadences: "Cadencia por canal",
        cadence_channel: "Canal",
        cadence_per_week: "Piezas por semana",
        add_cadence: "Añadir canal",
        remove_row: "Quitar fila",
      },
    },
    channels: {
      heading: "Canales",
      new: "Nuevo canal",
      edit: "Editar canal",
      empty: "Todavía no hay canales.",
      empty_hint: "Añade las cuentas de Litus en redes y el blog.",
      budget: "Presupuesto mensual",
      no_budget: "Sin presupuesto",
      per_month: "%{amount}/mes",
      objective: "Objetivo",
      open: "Abrir %{name}",
      pause: "Pausar canal",
      activate: "Activar canal",
      status_updated: "Canal %{status}",
      deleted: "Canal eliminado",
      delete: "Eliminar canal",
      pieces: "%{smart_count} pieza |||| %{smart_count} piezas",
      form: {
        platform: "Red",
        name: "Nombre",
        handle: "Usuario",
        url: "Enlace",
        objective: "Objetivo",
        monthly_budget: "Presupuesto mensual (€)",
        notes: "Notas",
      },
    },
    analytics: {
      heading: "Analíticas de contenido",
      period_label: "Periodo",
      period_30: "30 días",
      period_90: "90 días",
      period_all: "Todo",
      empty: "Todavía no hay métricas en este periodo.",
      empty_hint: "Registra las métricas semanales de una pieza o de un canal.",
      record: "Registrar métricas",
      totals: "Totales",
      key_numbers: "Las tres cifras de cada semana",
      key_numbers_hint:
        "Los guardados y los envíos indican si el contenido es útil; los mensajes directos, si llega a quien puede contratarnos.",
      weekly: "Evolución semanal",
      week_of: "Semana del %{day}",
      top_engagement: "Top piezas por interacción",
      top_leads: "Top piezas por leads",
      top_empty: "Sin datos suficientes.",
      by_channel: "Rendimiento por canal",
      by_format: "Rendimiento por formato",
      interactions: "Interacciones",
      engagement: "Engagement",
      engagement_help:
        "Engagement = (me gusta + comentarios + envíos + guardados) / alcance. Si no hay alcance, se usan las impresiones.",
      insights: "Qué funciona mejor",
      spend: "Gasto",
      insights_empty:
        "Hacen falta más piezas con métricas para sacar conclusiones.",
      chart_label: "Gráfico de %{name}",
      pieces_count: "%{smart_count} pieza |||| %{smart_count} piezas",
    },
    metric: {
      impressions: "Impresiones",
      reach: "Alcance",
      views: "Reproducciones",
      likes: "Me gusta",
      comments: "Comentarios",
      shares: "Envíos",
      saves: "Guardados",
      direct_messages: "Mensajes directos",
      clicks: "Clics",
      leads: "Leads",
      follows: "Nuevos seguidores",
      spend: "Gasto (€)",
    },
    insights: {
      best_format: "El formato con más engagement es %{format} (%{rate} %).",
      most_useful_format:
        "%{format} es el formato más útil: %{count} guardados y envíos por pieza.",
      best_channel: "%{channel} es el canal con más engagement (%{rate} %).",
      most_dms: "%{channel} trae más mensajes directos (%{count}).",
      best_weekday:
        "Lo publicado en %{day} rinde más: %{count} interacciones por pieza.",
      top_leads: "«%{title}» es la pieza que más leads ha traído (%{count}).",
      trend_up:
        "Guardados y envíos suben un %{change} % respecto a la semana anterior.",
      trend_down:
        "Guardados y envíos bajan un %{change} % respecto a la semana anterior.",
    },
    piece: {
      title: "Pieza",
      new: "Nueva pieza",
      edit: "Editar pieza",
      open: "Abrir pieza",
      not_found: "No se ha encontrado la pieza.",
      deleted: "Pieza eliminada",
      delete: "Eliminar pieza",
      scheduled: "Publicación prevista",
      published: "Publicada",
      no_date: "Sin fecha",
      weekday: "Día",
      plan: "Plan",
      phase: "Fase",
      week: "Semana del plan",
      pillar: "Pilar",
      pillars: "Pilares",
      channel: "Canal",
      assignee: "Responsable",
      brief: "Copy / brief",
      published_url: "Enlace publicado",
      view_post: "Ver publicación",
      metrics: "Métricas semanales",
      metrics_empty: "Todavía no hay métricas de esta pieza.",
      metrics_total: "Total",
      record: "Registrar métricas",
    },
    form: {
      save: "Guardar",
      cancel: "Cancelar",
      saved: "Guardado",
      error: "No se ha podido guardar. Inténtalo de nuevo.",
      delete_confirm: "¿Eliminar?",
      title: "Título",
      scheduled_at: "Fecha y hora de publicación",
      secondary_pillar: "Segundo pilar",
      title_required: "Escribe un título.",
      name_required: "Escribe un nombre.",
      week_invalid: "La semana tiene que ser un número entre 1 y 53.",
      date_invalid: "La fecha no es válida.",
      period_invalid: "El fin no puede ser anterior al inicio.",
      amount_invalid: "Revisa las cifras: tienen que ser números positivos.",
      pillar_incomplete: "Cada pilar necesita código y nombre.",
      pillar_duplicate: "Hay dos pilares con el mismo código.",
      phase_invalid: "Revisa las fases: número y semanas válidos.",
      phase_duplicate: "Hay dos fases con el mismo número.",
      cadence_invalid: "Las piezas por semana tienen que ser mayores que 0.",
      cadence_duplicate: "Hay un canal repetido en la cadencia.",
      week_start_required: "Elige la semana.",
      metrics_empty: "Escribe al menos una cifra.",
      duplicate_week: "Ya hay métricas de esa semana: edítalas.",
    },
    metrics_form: {
      title: "Registrar métricas",
      edit: "Editar métricas",
      target: "De",
      target_piece: "Pieza",
      target_channel: "Canal (sin pieza)",
      week: "Semana",
      week_hint: "Se guarda en el lunes de la semana: %{day}.",
      key: "Cifras clave",
      reach: "Alcance",
      interactions: "Interacciones",
      results: "Resultados",
      notes: "Notas",
    },
  },
};

export const marketingEnglishMessages: typeof marketingSpanishMessages = {
  marketing: {
    title: "Marketing",
    tabs: {
      label: "Marketing sections",
      summary: "Summary",
      calendar: "Calendar",
      pipeline: "Pipeline",
      plans: "Plans",
      channels: "Channels",
      analytics: "Analytics",
    },
    status: {
      label: "Status",
      idea: "Idea",
      guion: "Script",
      produccion: "In production",
      programado: "Scheduled",
      publicado: "Published",
    },
    format: {
      label: "Format",
      imagen: "Image",
      carrusel: "Carousel",
      reel: "Reel",
      short: "Short",
      video_largo: "Long video",
      post: "Post",
      story: "Story",
      anuncio: "Ad",
      articulo: "Article",
      otro: "Other",
    },
    vertical: {
      label: "Vertical",
      clinicas: "Clinics",
      inmobiliarias: "Real estate",
      pymes: "SMBs",
      general: "General",
      otro: "Other",
    },
    plan_status: {
      label: "Plan status",
      borrador: "Draft",
      activo: "Active",
      finalizado: "Finished",
    },
    channel_status: {
      label: "Channel status",
      activo: "Active",
      pausado: "Paused",
    },
    source: {
      manual: "Manual",
      agente: "Agent",
      api: "API",
    },
    common: {
      error: "The marketing data could not be loaded.",
      all_channels: "All channels",
      all_plans: "All plans",
      no_channel: "No channel",
      no_plan: "No plan",
      none: "None",
      unassigned: "Unassigned",
      new_piece: "New piece",
      week_short: "Wk %{week}",
      week_long: "Week %{week}",
      overdue: "Overdue",
      filter_channel: "Filter by channel",
      filter_plan: "Filter by plan",
      channels_short: "Channels",
      plans_short: "Plans",
    },
    summary: {
      heading: "Marketing summary",
      kpi_scheduled: "Scheduled this week",
      kpi_published: "Published this month",
      kpi_leads: "Leads this month",
      kpi_spend: "Spend this month",
      upcoming: "Upcoming posts",
      upcoming_empty: "Nothing is scheduled.",
      see_calendar: "See calendar",
      competitors: "Recent competitor activity",
      competitors_empty: "No competitor activity yet.",
      see_trends: "See trends",
      key_week: "This week",
      key_week_hint:
        "Saves, shares and direct messages of the latest week with data.",
    },
    calendar: {
      heading: "Content calendar",
      view_label: "Calendar view",
      month: "Month",
      week: "Week",
      list: "List",
      previous: "Previous",
      next: "Next",
      today: "Today",
      add_on_day: "New piece on %{day}",
      empty_day: "Nothing planned this day.",
      empty_list: "No pieces in this period.",
      more: "+%{count}",
      pieces: "%{smart_count} piece |||| %{smart_count} pieces",
    },
    pipeline: {
      heading: "Content pipeline",
      empty_column: "Drop here",
      moved: "Piece moved to “%{status}”",
      error: "The piece could not be moved.",
      status_label: "Column",
    },
    plans: {
      heading: "Content plans",
      new: "New plan",
      edit: "Edit plan",
      empty: "No plans yet.",
      empty_hint:
        "Create a plan with its pillars, phases and cadence per channel.",
      period: "Period",
      no_period: "No dates",
      weeks: "%{smart_count} week |||| %{smart_count} weeks",
      objective: "Goal",
      pillars: "Pillars",
      phases: "Phases",
      cadence: "Cadence per channel",
      per_week: "%{count}/week",
      progress: "Progress",
      progress_value: "%{published} of %{planned} published",
      target: "Cadence target: %{count} pieces",
      pieces: "Plan pieces",
      no_pieces: "This plan has no pieces yet.",
      no_week: "No week",
      phase_name: "Phase %{number}",
      phase_weeks: "Weeks %{from}–%{to}",
      back: "Back to plans",
      not_found: "Plan not found.",
      deleted: "Plan deleted",
      delete: "Delete plan",
      current_week: "Current week",
      form: {
        name: "Name",
        objective: "Goal",
        start_date: "Start",
        end_date: "End",
        notes: "Notes",
        pillars: "Pillars",
        pillar_code: "Code",
        pillar_name: "Pillar name",
        pillar_description: "Description",
        add_pillar: "Add pillar",
        phases: "Phases",
        phase_number: "No.",
        phase_name: "Name",
        phase_start: "First week",
        phase_end: "Last week",
        phase_cadence: "Pace",
        add_phase: "Add phase",
        cadences: "Cadence per channel",
        cadence_channel: "Channel",
        cadence_per_week: "Pieces per week",
        add_cadence: "Add channel",
        remove_row: "Remove row",
      },
    },
    channels: {
      heading: "Channels",
      new: "New channel",
      edit: "Edit channel",
      empty: "No channels yet.",
      empty_hint: "Add Litus' social accounts and the blog.",
      budget: "Monthly budget",
      no_budget: "No budget",
      per_month: "%{amount}/month",
      objective: "Goal",
      open: "Open %{name}",
      pause: "Pause channel",
      activate: "Activate channel",
      status_updated: "Channel %{status}",
      deleted: "Channel deleted",
      delete: "Delete channel",
      pieces: "%{smart_count} piece |||| %{smart_count} pieces",
      form: {
        platform: "Network",
        name: "Name",
        handle: "Handle",
        url: "Link",
        objective: "Goal",
        monthly_budget: "Monthly budget (€)",
        notes: "Notes",
      },
    },
    analytics: {
      heading: "Content analytics",
      period_label: "Period",
      period_30: "30 days",
      period_90: "90 days",
      period_all: "All",
      empty: "No metrics in this period yet.",
      empty_hint: "Record the weekly metrics of a piece or a channel.",
      record: "Record metrics",
      totals: "Totals",
      key_numbers: "The three numbers of each week",
      key_numbers_hint:
        "Saves and shares tell whether the content is useful; direct messages, whether it reaches people who can hire us.",
      weekly: "Weekly evolution",
      week_of: "Week of %{day}",
      top_engagement: "Top pieces by interactions",
      top_leads: "Top pieces by leads",
      top_empty: "Not enough data.",
      by_channel: "Performance by channel",
      by_format: "Performance by format",
      interactions: "Interactions",
      engagement: "Engagement",
      engagement_help:
        "Engagement = (likes + comments + shares + saves) / reach. Without reach, impressions are used.",
      insights: "What works best",
      spend: "Spend",
      insights_empty:
        "More pieces with metrics are needed to draw conclusions.",
      chart_label: "%{name} chart",
      pieces_count: "%{smart_count} piece |||| %{smart_count} pieces",
    },
    metric: {
      impressions: "Impressions",
      reach: "Reach",
      views: "Views",
      likes: "Likes",
      comments: "Comments",
      shares: "Shares",
      saves: "Saves",
      direct_messages: "Direct messages",
      clicks: "Clicks",
      leads: "Leads",
      follows: "New followers",
      spend: "Spend (€)",
    },
    insights: {
      best_format:
        "The format with the most engagement is %{format} (%{rate} %).",
      most_useful_format:
        "%{format} is the most useful format: %{count} saves and shares per piece.",
      best_channel:
        "%{channel} is the channel with the most engagement (%{rate} %).",
      most_dms: "%{channel} brings the most direct messages (%{count}).",
      best_weekday:
        "Pieces published on %{day} perform best: %{count} interactions per piece.",
      top_leads:
        "“%{title}” is the piece that brought the most leads (%{count}).",
      trend_up: "Saves and shares are up %{change} % on the previous week.",
      trend_down: "Saves and shares are down %{change} % on the previous week.",
    },
    piece: {
      title: "Piece",
      new: "New piece",
      edit: "Edit piece",
      open: "Open piece",
      not_found: "Piece not found.",
      deleted: "Piece deleted",
      delete: "Delete piece",
      scheduled: "Planned publication",
      published: "Published",
      no_date: "No date",
      weekday: "Day",
      plan: "Plan",
      phase: "Phase",
      week: "Plan week",
      pillar: "Pillar",
      pillars: "Pillars",
      channel: "Channel",
      assignee: "Owner",
      brief: "Copy / brief",
      published_url: "Published link",
      view_post: "View post",
      metrics: "Weekly metrics",
      metrics_empty: "No metrics for this piece yet.",
      metrics_total: "Total",
      record: "Record metrics",
    },
    form: {
      save: "Save",
      cancel: "Cancel",
      saved: "Saved",
      error: "Could not save. Please try again.",
      delete_confirm: "Delete?",
      title: "Title",
      scheduled_at: "Publication date and time",
      secondary_pillar: "Second pillar",
      title_required: "Enter a title.",
      name_required: "Enter a name.",
      week_invalid: "The week must be a number between 1 and 53.",
      date_invalid: "The date is not valid.",
      period_invalid: "The end cannot be before the start.",
      amount_invalid: "Check the figures: they must be positive numbers.",
      pillar_incomplete: "Each pillar needs a code and a name.",
      pillar_duplicate: "Two pillars share the same code.",
      phase_invalid: "Check the phases: valid number and weeks.",
      phase_duplicate: "Two phases share the same number.",
      cadence_invalid: "Pieces per week must be greater than 0.",
      cadence_duplicate: "A channel is repeated in the cadence.",
      week_start_required: "Pick the week.",
      metrics_empty: "Enter at least one figure.",
      duplicate_week: "That week already has metrics: edit them.",
    },
    metrics_form: {
      title: "Record metrics",
      edit: "Edit metrics",
      target: "For",
      target_piece: "Piece",
      target_channel: "Channel (no piece)",
      week: "Week",
      week_hint: "Saved on the Monday of the week: %{day}.",
      key: "Key numbers",
      reach: "Reach",
      interactions: "Interactions",
      results: "Results",
      notes: "Notes",
    },
  },
};
